<app-page-body>
  <!-- header -->
  @if(!isModalMode){
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    [showRefreshBtn]="!isModalMode"
    [showBackBtn]="!isModalMode"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>
  }

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset [ngClass]="{ '!tw-border-0': isModalMode }">
          @if(!isModalMode){
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>
          }

          <div class="row" [ngClass]="{ 'tw-p-9': !isModalMode }">
            <!-- fieldType -->
            <div
              [ngClass]="
                isModalMode
                  ? 'md:tw-w-full'
                  : ' xl:tw-w-1/3 2xl:tw-w-1/4 sm:tw-w-1/2'
              "
            >
              <enum-select-search
                class="tw-w-full"
                enumName="FormBuilderFieldTypes"
                [label]="fields + 'fieldType'"
                [control]="form?.get('fieldType')"
                [(value)]="model.fieldType"
                (valueChange)="changeFieldType()"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- title -->
            <div
              [ngClass]="
                isModalMode
                  ? 'md:tw-w-full'
                  : ' xl:tw-w-1/3 2xl:tw-w-1/4 sm:tw-w-1/2'
              "
            >
              <form-field
                [(value)]="model.title"
                [control]="form?.get('title')"
                [label]="'common.title' | translate"
              >
              </form-field>
            </div>

            <app-form-fields-validations
              [fieldsClass]="
                model.fieldType === FormBuilderFieldTypes.Date
                  ? 'tw-w-full'
                  : isModalMode
                  ? '!tw-w-full'
                  : 'sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4'
              "
              [isModalMode]="isModalMode"
              [fieldType]="model.fieldType"
              [isEditMode]="formPageConfig.isEditMode"
              [(model)]="model.validation"
            ></app-form-fields-validations>

            @if(isShowSelectList){ @for (rule of newDropDownModel; track $index;
            let last = $last) {
            <!--fields-->
            <app-drop-down-fields
              [valueClass]="
                isModalMode
                  ? 'tw-w-full'
                  : 'xl:tw-w-1/3 2xl:tw-w-1/4 sm:tw-w-1/2'
              "
              [isEdit]="formPageConfig?.isEditMode"
              [model]="newDropDownModel[$index]"
              [index]="$index"
              (option)="newDropDownModel[$index] = $event"
              (addOption)="onAddOption()"
              (removeOption)="onRemoveOption($event)"
              [showDeleteOptionBtn]="newDropDownModel.length > 1"
              [showAddOptionBtn]="last"
              (form)="createDropDownForms[$index] = $event"
            >
            </app-drop-down-fields>
            } }

            <!-- isRequired -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <mat-slide-toggle
                formControlName="isRequired"
                [(ngModel)]="model.isRequired"
              >
                {{ "common.isRequired" | translate }}
              </mat-slide-toggle>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
